export const LOAD_DASHBOARD_STATS = 'LOAD_DASHBOARD_STATS'
export const LOAD_SALES_STATISTICS = 'LOAD_SALES_STATISTICS'
export const LOAD_STATISTICS = 'LOAD_STATISTICS'
export const LOAD_WIDGETS = 'LOAD_WIDGETS'
export const LOAD_USER_WIDGETS = 'LOAD_USER_WIDGETS'


